import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { AuthService } from '../common/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  constructor(private _http: HttpClient, private _auth: AuthService) { }

  readonly ROOT_URL: string = environment.baseURI;

  private handleError(error: HttpErrorResponse) {
    if (error) {
      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.message);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong.
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.message}`
        );
      }
      // Return an observable with a user-facing error message.
      // return throwError('Something bad happened; please try again later.');
      let errors = {
        Error: error.error,
        Message: error.message,
        Status: error.status,
      };
      if (error.status === 401) {
        // Optionally handle unauthorized (session timeout) differently
        this._auth.clearToken();
    }
      return throwError(errors);
    }
    return throwError(error);
  }

  encryption(object: any) {
    var encryptedBase64Key: any = environment.encryptionKey;
    encryptedBase64Key = CryptoJS.enc.Utf8.parse(encryptedBase64Key);

    // console.log('Original Data = ', JSON.stringify(object));
    var encrypted: any = CryptoJS.AES.encrypt(
      JSON.stringify(object),
      encryptedBase64Key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    // console.log('encryptedData = ', encrypted.toString());
    return {
      EncryptedRequest: encrypted.toString(),
      SecrectKey: environment.encryptionKey,
    };
  }

  decryption(data: string) {

    var encryptedBase64Key: any = environment.encryptionKey;
    encryptedBase64Key = CryptoJS.enc.Utf8.parse(encryptedBase64Key);

    var encrypted: any = CryptoJS.AES.decrypt(
      data,
      encryptedBase64Key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    // console.log('decrypted = ', encrypted.toString(CryptoJS.enc.Utf8));
  }


  get(url: string) {
    return this._http.get<any>(this.ROOT_URL + url).pipe(
      catchError((error: any) => {
        console.log("error is:",error);
        return this.handleError(error);
      })
    );
  }

  post(
    url: string,
    object: any,
    encryptReq: boolean = true,
    encryptRes: boolean = false
  ) {
    if (encryptReq) {
      object = this.encryption(object);
    }
    let headers = new HttpHeaders();
    const token = this._auth.getToken();
    let header;
    if (token) {
      header = headers.append('Authorization', `Bearer ${token}`);
    }
    return this._http
      .post<any>(this.ROOT_URL + url, object, { headers: header })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.log("error is:",error);
          return this.handleError(error);
        })
      );
  }

  authenticate(formObject: any) {
    return this.post('authenticate', formObject);
  }

  sendNoti(formObject: any) {
    return this.post('kitchenappPushNotification', formObject);
  }

  forgetPassword(formObject: any) {
    return this.post('getOtpForForgotPassword', formObject);
  }

  verifyPassword(formObject: any) {
    return this.post('verifyOtpForForgotUserPassword', formObject);
  }

  aboutMe(formObject: any) {
    return this.post('aboutMe', formObject, false);
  }

  getAllService(formData: any) {
    return this.post('getAllService', formData, false);
  }
  getrestLanguage(formObject: any) {
    return this.post('getLangBasedOnRest', formObject, false);
  }

  // Product Start
  getProductLists(formObject: any) {
    return this.post('getAllProductList', formObject);
  }

  getProductList(formObject: any) {
    return this.post('viewProduct', formObject);
  }

  addProduct(formObject: any) {
    return this.post('addProduct', formObject, false);
  }

  updateProduct(formObject: any) {
    // alert("hai");
    //alert("formObject"+JSON.stringify(formObject));
    return this.post('addProduct', formObject, false);
  }

  deleteProduct(formObject: any) {
    return this.post('softDeleteProduct', formObject);
  }

  deleteProductSize(formObject: any) {
    return this.post('deleteProductSizeMap', formObject);
  }

  deleteAllProduct(formObject: any) {
    return this.post('deleteAllProduct', formObject);
  }

  addSubProduct(formObject: any) {
    //return this.post('addProductSubProduct', formObject);
    return this.post('addProductSubProduct', formObject, false);
  }

  updateProductstatus(formObject: any) {
    //return this.post('addProductSubProduct', formObject);
    return this.post('updateProductstatus', formObject);
  }

  updateProductSidesCount(formObject: any) {
    //return this.post('addProductSubProduct', formObject);
    return this.post('updateProductSideCount', formObject);
  }

  getSelectedProductLists(formObject: any) {
    //return this.post('addProductSubProduct', formObject);
    return this.post('getProductSubProduct', formObject);
  }
  // Product end

  //ComboMeals Start
  getComboMealsLists(formObject: any) {
    return this.post('getAllComboMealsList', formObject);
  }

  getComboMealsList(formObject: any) {
    return this.post('viewComboMeals', formObject);
  }

  addComboMeals(formObject: any) {
    return this.post('addComboMeals', formObject, false);
  }

  updateComboMeals(formObject: any) {
    return this.post('addComboMeals', formObject, false);
  }

  deleteComboMeals(formObject: any) {
    return this.post('softDeleteComboMeals', formObject);
  }

  deleteAllComboMeals(formObject: any) {
    return this.post('deleteAllComboMeals', formObject);
  }
  //ComboMeals end

  //Section Start
  getSectionLists(formObject: any) {
    return this.post('getAllSectionList', formObject);
  }



  getSectionList(formObject: any) {
    return this.post('viewSection', formObject);
  }

  addSection(formObject: any) {
    return this.post('addSection', formObject);
  }

  addType(formObject: any) {
    return this.post('addType', formObject);
  }

  getTypeLists(formObject: any) {
    return this.post('getAllTypeList', formObject);
  }

  getTypeList(formObject: any) {
    return this.post('viewType', formObject);
  }

  updateType(formObject: any) {
    return this.post('addType', formObject);
  }

  deleteType(formObject: any) {
    return this.post('softDeleteSection', formObject);
  }

  deleteAllType(formObject: any) {
    return this.post('deleteAllType', formObject);
  }

  updateSection(formObject: any) {
    return this.post('addSection', formObject);
  }

  deleteSection(formObject: any) {
    return this.post('softDeleteSection', formObject);
  }

  deleteAllSection(formObject: any) {
    return this.post('deleteAllSection', formObject);
  }
  //Section end

  //Category Start
  getCategoryLists(formObject: any) {
    return this.post('getAllCategoryList', formObject);
  }

  getCategoryList(formObject: any) {
    return this.post('viewCategory', formObject);
  }

  addCategory(formObject: any) {
    return this.post('addCategory', formObject, false);
  }

  updateCategory(formObject: any) {
    //alert(formObject.EncryptedRequest);
    return this.post('addCategory', formObject, false);
  }

  deleteCategory(formObject: any) {
    return this.post('softDeleteCategory', formObject);
  }

  deleteAllCategory(formObject: any) {
    return this.post('deleteAllCategory', formObject);
  }
  //Category end


  //Sub Category start
  addSubCategory(formObject: any) {
    return this.post('addSubCategory', formObject, false);
  }

  getSubCategoryLists(formObject: any) {
    return this.post('getAllSubCategoryList', formObject);
  }

  editSubCategory(formObject: any) {
    return this.post('addSubCategory', formObject, false);
  }

  getSubCategoryList(formObject: any) {
    return this.post('viewSubCategory', formObject);
  }

  getSubCategoryListsofCategory(formObject: any) {
    return this.post('getSubCategories', formObject);
  }
  deleteAllSubcategory(formObject: any) {
    return this.post('deleteAllSubcategory', formObject);
  }

  //service
  addService(formObject: any) {
    return this.post('addService', formObject, true);
  }
  //surcharge

  SurchargeDetail(formObject: any) {
    return this.post('ListOneTimeSurchargeDetail', formObject, true);
  }
  //add language
  addLanguage(formObject: any) {
    return this.post('addLanguage', formObject);
  }

  updateLanguage(formObject: any) {
    return this.post('addLanguage', formObject);
  }

  deleteLanguage(formObject: any) {
    return this.post('softDeleteLanguage', formObject);
  }

  deleteAllLanguage(formObject: any) {
    return this.post('deleteAllLanguage', formObject);
  }

  //foryou category

  addForYouCategory(formObject: any) {
    return this.post('addForYouCategory', formObject, false);
  }

  getForYouCategoryLists(formObject: any) {
    return this.post('getForYouCategoryLists', formObject);
  }

  updateForYouCategory(formObject: any) {
    return this.post('addForYouCategory', formObject);
  }
  //Modifier Start
  getModifierLists(formObject: any) {
    return this.post('getAllModifierList', formObject);
  }

  getModifierList(formObject: any) {
    return this.post('viewModifier', formObject);
  }

  addModifier(formObject: any) {
    return this.post('addModifier', formObject);
  }

  updateModifier(formObject: any) {
    return this.post('addModifier', formObject);
  }

  deleteModifier(formObject: any) {
    return this.post('softDeleteModifier', formObject);
  }

  deleteAllModifier(formObject: any) {
    return this.post('deleteAllModifier', formObject);
  }
  //Modifier end

  //Table Start
  getTableLists(formObject: any) {
    return this.post('getAllTableList', formObject);
  }

  getTableList(formObject: any) {
    return this.post('viewTable', formObject);
  }

  addTable(formObject: any) {
    return this.post('addTable', formObject);
  }

  updateTable(formObject: any) {
    return this.post('addTable', formObject);
  }

  deleteTable(formObject: any) {
    return this.post('softDeleteTable', formObject);
  }

  deleteAllTable(formObject: any) {
    return this.post('deleteAllRestaurantTable', formObject);
  }
  //Table end

  getAllOrderPlacedList(formObject: any) {
    return this.post('getAllOrderPlacedList', formObject);
  }

  getAllTransactionList(formObject: any) {
    return this.post('getAllTransactionList', formObject);
  }

  getAllTransactionCancelList(formObject: any) {
    return this.post('getAllTransactionCancelList', formObject);
  }

  deleteOrder(formObject: any) {
    return this.post('deleteOrder', formObject);
  }

  viewOrderPlaced(formObject: any) {
    return this.post('viewOrderPlaced', formObject);
  }

  getAllOrderCancelList(formObject: any) {
    return this.post('getAllOrderCancelList', formObject);
  }

  tableChangeId = new Subject<any>();
  updatetableId(tableID: number) {
    this.tableChangeId.next(tableID);
  }

  ListItemDetail: string = 'ListItemDetail';
  getListItemDetails(formObject: any) {
    return this.post(this.ListItemDetail, formObject);
  }

  getAllRestaurantList(formObject: any) {
    console.log("call api");
    return this.post('getAllRestaurantList', formObject);
  }

  getAllLanguageList(formObject: any) {
    console.log("call api");
    return this.post('getAllLanguages', formObject);
  }

  getLanguageDet(formObject: any) {
    return this.post('viewLanguage', formObject);
  }

  getRestaurant(formObject: any) {
    return this.post('viewRestaurant', formObject);
  }

  addRestaurant(formObject: any) {
    return this.post('addRestaurant', formObject);
  }

  // Which Stripe account a venue's payments run on. Deliberately separate from
  // addRestaurant, which goes through a 27 column UPDATE shared by other fields.
  updateVenueStripeAccount(formObject: any) {
    return this.post('updateVenueStripeAccount', formObject);
  }

  softDeleteRestaurant(formObject: any) {
    return this.post('softDeleteRestaurant', formObject);
  }

  deleteAllRestaurant(formObject: any) {
    return this.post('deleteAllRestraunt', formObject);
  }

  getContactList(formObject: any) {
    return this.post('viewContact', formObject);
  }

  getAllContactLists(formObject: any) {
    return this.post('getAllContactList', formObject);
  }

  SoftDeleteContact(formObject: any) {
    return this.post('softDeleteContact', formObject);
  }

  deleteAllContact(formObject: any) {
    return this.post('deleteAllContact', formObject);
  }

  addContact(formObject: any) {
    return this.post('addContact', formObject);
  }

  getUserDashboard(formObject: any) {
    return this.post('Dashboard', formObject);
  }

  getAdminDashboard(formObject: any) {
    return this.post('DashboardSuperAdmin', formObject);
  }

  updatePassword(formObject: any) {
    return this.post('UpdateUserPassword', formObject);
  }

  //Tag Start
  getTagLists(formObject: any) {
    return this.post('getAllTagList', formObject);
  }

  getTagList(formObject: any) {
    return this.post('viewTags', formObject);
  }

  addTag(formObject: any) {
    return this.post('addTags', formObject);
  }

  updateTag(formObject: any) {
    return this.post('addTags', formObject);
  }

  deleteTag(formObject: any) {
    return this.post('softDeleteTags', formObject);
  }

  deleteAllTag(formObject: any) {
    return this.post('deleteAllTags', formObject);
  }
  //Tag end

  addRestProperty(formObject: any) {
    return this.post('addRestProperty', formObject, false);
  }

  getPropertyList(formObject: any) {
    return this.post('getPropertyList', formObject, false);
  }

  getAllRatingList(formObject: any) {
    return this.post('getAllRatingList', formObject);
  }

  getAllCustOrderList(formObject: any) {
    return this.post('getOrderDetail', formObject);
  }

  getAllUserList(formObject: any) {
    return this.post('getAllRegisteredCustomer', formObject);
  }


  getAddSlider(formObject: any) {
    return this.post('addSlider', formObject, false);
  }

  getSliderBanner(formObject: any) {
    return this.post('viewSlider', formObject);
  }

  getDeleteSlider(formObject: any) {
    return this.post('deleteSlider', formObject, false);
  }

  // Promo Code

  getAddPromoCode(formObject: any) {
    return this.post('addPromoCode', formObject, false);
  }

  getAllPromoCodeList(formObject: any) {
    return this.post('getAllPromoCodeList', formObject, true);
  }

  getViewOrderDetails(formObject: any) {
    return this.post('viewOrderDetails', formObject, false);
  }

  getEditUnitPrice(formObject: any) {
    return this.post('EditType', formObject, false);
  }

  getLangBasedOnRest() {
    return this.post('getLangBasedOnRest', false);
  }

  public stringSubject = new Subject<string>();

  passValue(data: any) {
    //passing the data as the next observable
    this.stringSubject.next(data);
  }


  addModifierCSV(formObject: any) {
    return this.post('addModifierCSV', formObject, false);
  }


  addSubCategoryCSV(formObject: any) {
    return this.post('addSubCategoryCSV', formObject, false);
  }


  addProductBulk(formObject: any) {
    return this.post('addProductBulk', formObject, false);
  }
  addCategoryCSV(formObject: any) {
    return this.post('addCategoryCSV', formObject, false);
  }
  addSectionCSV(formObject: any) {
    return this.post('addSectionCSV', formObject, false);
  }

  addTableCSV(formObject: any) {
    return this.post('addTableCSV', formObject, false);
  }

  addTypeCSV(formObject: any) {
    return this.post('addTypeCSV', formObject, false);
  }

  addOneTimeSurCharge(formObject: any) {
    return this.post('addOneTimeSurCharge', formObject, true);
  }


  SurCharge(formObject: any) {
    return this.post('addSurCharge', formObject, true);
  }

  SurChargeUpcomming(formObject: any) {
    return this.post('ListOneTimeSurcharge', formObject, true);
  }

  //sub restaurant list
  getSubRestaurantList(formObject: any) {
    //return this.post('addProductSubProduct', formObject);
    return this.post('getSubRestauratList', formObject);
  }

  addSubRestaurant(formObject: any) {
    //return this.post('addProductSubProduct', formObject);
    return this.post('addSubRestaurant', formObject, false);
  }

  getUpdateRestStatus(formObject: any) {
    return this.post('updateRestStatus', formObject, true);
  }

  setWaitTime(formObject:any){
    return this.post('updateWaitTime',formObject,true);
  }
  getWaitTime(formObject:any){
    return this.post('getWaitTime',formObject)
  }
  // promoCode
  getUpdatePromoCode(formObject: any) {
    return this.post('updatePromoCode', formObject, true);
  }
  getSoftDeletePromoCode(formObject: any) {
    return this.post('softDeletePromoCode', formObject, true);
  }
  viewPromoCode(formObject: any) {
    return this.post('viewPromoCode', formObject, true);
  }


  getdoshi(formObject: any) {
    return this.post('get_doshii_order_list', formObject, true);
  }

  doshi_order_create(formObject: any) {
    return this.post('doshi_order_create', formObject);
  }

  getAllProductListByCategory(formObject: any) {
    return this.post('getAllProductListByCategory', formObject);
  }

  updateSubCategoryStatus(formObject: any) {
    return this.post('updateSubCategoryStatus', formObject);
  }

  updateCategoryStatus(formObject: any) {
    return this.post('updateCategoryStatus', formObject);
  }
  softDeleteSubCategory(formObject: any) {
    return this.post('softDeleteSubCategory', formObject, true);
  }
  updateSectionStatus(formObject: any) {
    return this.post('updateSectionStatus', formObject, true);
  }
  updateTableStatus(formObject: any) {
    return this.post('updateTableStatus', formObject, true);
  }

  // sub ModiFier
  addModifierSubtype(formObject: any) {
    return this.post('addModifierSubtype', formObject, true);
  }

  getAllModifierSubtype(formObject: any) {
    return this.post('getAllModifierSubtype', formObject, true);
  }

  viewModifierSubtype(formObject: any) {
    return this.post('viewModifierSubtype', formObject, true);
  }

  softDeleteModSubtype(formObject: any) {
    return this.post('softDeleteModSubtype', formObject, true);
  }

  deleteAllModifierSubtype(formObject: any) {
    return this.post('deleteAllModifierSubtype', formObject, true);
  }

  // Sub ModiFier type

  addModifierType(formObject: any) {
    return this.post('addModifiertype', formObject, true);
  }

  getAllModifierType(formObject: any) {
    return this.post('getAllModifierType', formObject, true);
  }

  viewModifierType(formObject: any) {
    return this.post('viewModifierType', formObject, true);
  }

  softDeleteModType(formObject: any) {
    return this.post('softDeleteModType', formObject, true);
  }

  deleteAllModifierType(formObject: any) {
    return this.post('deleteAllModifierType', formObject, true);
  }

  // Refund API
  refundOrderAmount(formObject: any) {
    return this.post('refundOrderAmount', formObject, true);
  }

  // Bulk Price API

  getAllProductForBulkprice(formObject: any) {
    return this.post('getAllProductForBulkprice', formObject, true);
  }
  bulkPriceUpdate(formObject: any) {
    return this.post('bulkPriceUpdate', formObject, true);
  }

  getAllSubCategoryListByRest(formObject: any) {
    return this.post('getAllSubCategoryListByRest', formObject, true);
  }

  softDeleteService(formObject: any) {
    return this.post('softDeleteService', formObject, true);
  }

  getAllSpecialService(formObject: any) {
    return this.post('getAllSpecialService', formObject, true);
  }

  getAllProductListBySubcategory(formObject: any) {
    return this.post('getAllProductListBySubcategory', formObject, true);
  }

  viewService(formObject: any) {
    return this.post('viewService', formObject, true);
  }
  getAllOrderByStatus(formObject:any){
    return this.post('getAllOrderByStatus',formObject,true);
  }

  // Global Option

  addGlobalOption(formObject: any) {
    return this.post('addGlobalOption', formObject, true);
  }

  viewGlobalOption(formObject: any) {
    return this.post('viewGlobalOption', formObject, true);
  }

  softDeleteGlobalOpt(formObject: any) {
    return this.post('softDeleteGlobalOpt', formObject, true);
  }

  deleteAllGlobalOption(formObject: any) {
    return this.post('deleteAllGlobalOption', formObject, true);
  }

  getAllGlobalOption(formObject: any) {
    return this.post('getAllGlobalOption', formObject, false);
  }
  productModifierbulkUpdate(formObject: any) {
    return this.post('productModifierbulkUpdate', formObject, true);
  }
  viewProductmodifier(formObject: any) {
    return this.post('viewProductmodifier', formObject, true);
  }


  getAllDashBoardSuperAdminList(formObject: any) {
    return this.post('getAllDashBoardSuperAdminList', formObject, true);
  }

  
  getTransactionListSuperAdmin(formObject: any) {
    return this.post('getTransactionListSuperAdmin', formObject, true);
  }

  filterByDataRange_Venue(formObject: any) {
    return this.post('filterByDataRange_Venue', formObject, true);
  }

  getAllActiveOrderList(formObject: any) {
    return this.post('getAllActiveOrderList', formObject, true);
  }

  //Calorie

  addCalorieFilter(formObject: any) {
    return this.post('addCalorieFilter', formObject, true);
  }

  getAllCalorieFilter(formObject: any) {
    return this.post('getAllCalorieFilter', formObject, true);
  }

  viewCalorieFilter(formObject: any) {
    return this.post('viewCalorieFilter', formObject, true);
  }

  softDeleteCalorieFilter(formObject: any) {
    return this.post('softDeleteCalorieFilter', formObject, true);
  }

  deleteAllCalorieFilter(formObject: any) {
    return this.post('deleteAllCalorieFilter', formObject, true);
  }

   //Tags

  addTagFilter(formObject: any) {
    return this.post('addTagFilter', formObject, true);
  }

  getAllTagFilter(formObject: any) {
    return this.post('getAllTagFilter', formObject, true);
  }

  viewTagFilter(formObject: any) {
    return this.post('viewTagFilter', formObject, true);
  }

  softDeleteTagFilter(formObject: any) {
    return this.post('softDeleteTagFilter', formObject, true);
  }

  deleteAllTagFilter(formObject: any) {
    return this.post('deleteAllTagFilter', formObject, true);
  }

  // doshi status 
  
  getAllOrdersList(formObject: any) {
    return this.post('getAllOrdersList', formObject, true);
  }

  viewAllOrdersByDateAndStatus(formObject: any) {
    return this.post('viewAllOrdersByDateAndStatus', formObject, true);
  }
///////////////////////////////
// 111
// 
}
